















































import { Component, Vue, Watch } from 'vue-property-decorator'
import { AppStoreModule as appStore } from '@/shared/config/store/app-store'

@Component({
  name: 'Login'
})
export default class extends Vue {
  get language() {
    return appStore.language
  }

  private handleSetLanguage(lang: string) {
    this.$i18n.locale = lang
    appStore.SetLanguage(lang)
    this.$message({
      message: 'Switch Language Success',
      type: 'success'
    })
  }
}
